<template>
  <div id="gallery" class="gallery-wrap pb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style4 text-center mb-40">
            <span>Gallery Exhibition</span>
            <h2>
              Discover Your Health & Recovery Works For Our Medical Clinic
            </h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="gallery-slider-two"
      >
        <Slide v-for="gallery in galleries" :key="gallery.id">
          <div class="gallery-card style4">
            <div class="gallery-img">
              <img :src="gallery.image" alt="Image" />
              <div class="gallery-info">
                <div class="gallery-info-left">
                  <h3>
                    <router-link to="/gallery-details">
                      {{ gallery.title }}
                    </router-link>
                  </h3>
                  <span>{{ gallery.tag }}</span>
                </div>
                <div class="gallery-info-right">
                  <router-link class="gallery-icon" to="/gallery-details">
                    <i class="ri-add-line"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Pagination />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Slide, Pagination } from "vue3-carousel";

export default defineComponent({
  name: "GalleryExhibition",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    galleries: [
      {
        id: 1,
        image: require("../../assets/images/gallery/gallery-14.jpg"),
        title: "Healthy Life",
        tag: "Chronic Desease",
      },
      {
        id: 2,
        image: require("../../assets/images/gallery/gallery-15.jpg"),
        title: "Pet Health",
        tag: "Pet Care",
      },
      {
        id: 3,
        image: require("../../assets/images/gallery/gallery-16.jpg"),
        title: "Medical Test",
        tag: "Labratory",
      },
      {
        id: 4,
        image: require("../../assets/images/gallery/gallery-17.jpg"),
        title: "Clinical Surgery",
        tag: "Pulmonary",
      },
      {
        id: 5,
        image: require("../../assets/images/gallery/gallery-18.jpg"),
        title: "Adult Care",
        tag: "Parenting",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      992: {
        itemsToShow: 3,
        snapAlign: "center",
      },
      1200: {
        itemsToShow: 4,
        snapAlign: "start",
      },
    },
  }),
});
</script>